import { useEffect, useRef, useState } from "react";
import axios, { API } from "../../api";

/**
 * Email verification landing page.
 * Reads token from URL hash (#verify-email=TOKEN) and posts it.
 * Auto-redirects to home after success.
 */
export function VerifyEmailScreen({ token, onDone }) {
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [error, setError] = useState("");
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;
    if (!token) {
      setStatus("error");
      setError("Missing verification token");
      return;
    }
    (async () => {
      try {
        await axios.post(`${API}/auth/verify-email`, { token });
        setStatus("success");
        // Clear the hash so reloads don't retry
        try { window.history.replaceState(null, "", window.location.pathname); } catch (_) {}
        setTimeout(() => { onDone?.(); }, 2200);
      } catch (e) {
        setStatus("error");
        setError(e?.response?.data?.detail || "Verification failed");
      }
    })();
  }, [token, onDone]);

  return (
    <div className="app-container">
      <div className="init-screen">
        <div className="init-content auth-form" data-testid="verify-email-screen">
          {status === "loading" && (
            <>
              <h2 className="auth-title">Verifying your email...</h2>
              <p style={{ opacity: 0.7, marginTop: "0.5rem" }}>One second.</p>
            </>
          )}
          {status === "success" && (
            <>
              <div style={{ fontSize: "3rem", textAlign: "center" }}>✨</div>
              <h2 className="auth-title">You're verified!</h2>
              <p style={{ opacity: 0.85 }}>Welcome to Aura. Taking you in...</p>
            </>
          )}
          {status === "error" && (
            <>
              <h2 className="auth-title">Oops</h2>
              <p style={{ color: "#fca5a5" }} data-testid="verify-error">{error}</p>
              <button
                className="init-btn"
                onClick={onDone}
                data-testid="verify-back-btn"
              >Continue to Aura</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
